/**
 * The layout of one launched locale's literal prefix (`/pk/en`, web plan
 * W4.3), for the route modules W4.4 / W4.5 register under it: its pages get
 * the catalogue of the URL's literal segment (`/pk/en` → `en`, W3.0) — never
 * the browser's language, a cookie or a query parameter (master D-11).
 */
import { Outlet } from 'react-router';
import { useRouteLocale } from '@/hooks/useRouteLocale';
import { LocaleLanguage } from '@/i18n/LocaleLanguage';

export default function LocaleLayout() {
  return (
    <LocaleLanguage locale={useRouteLocale()}>
      <Outlet />
    </LocaleLanguage>
  );
}
